import { BrowserRouter, Route, Routes } from "react-router-dom"
import { BlogSinglePage } from "./components/common/BlogSinglePage"
import { BlogSinglePage2 } from "./components/common/BlogSinglePage2"
import { BlogSinglePage3 } from "./components/common/BlogSinglePage3"
import { Layout } from "./components/common/Layout"
import { About } from "./pages/About"
import AviacionComercialCevatur from "./pages/aviacion"
import BartenderCevatur from "./pages/bartender"
import { Blog } from "./pages/Blog"
import ChefCevatur from "./pages/cheff"
import { Courses } from "./pages/Courses"
import GalleryCE from "./pages/GalleryCE"
import GalleryCN from "./pages/GalleryCN"
import Trayectoria from "./pages/Trayectoria"
import { Home } from "./pages/Home"
import { Instructor } from "./pages/Instructor"
import { default as TeamMembers, default as TeamSection } from "./pages/profav"
import TeamProfiles from "./pages/Profchef"


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>

        
          <Route
            path='/'
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path='/about'
            element={
              <Layout>
                <About />
              </Layout>
            }
          />
          <Route
            path='/profchef'
            element={
              <Layout>
                  <TeamProfiles />
              </Layout>
            }
          />

          <Route
            path='/profbar'
            element={
              <Layout>
                  <TeamMembers />
              </Layout>
            }
          />
          <Route
            path='/Careers'
            element={
              <Layout>
                <Courses />
              </Layout>
            }
          />
          <Route
            path='/Galeria'
            element={
              <Layout>
                <Instructor />
              </Layout>
            }
          />
          <Route
            path='/GaleriaCE'
            element={
              <Layout>
                <GalleryCE />
              </Layout>
            }
          />
          <Route
            path='/GaleriaCN'
            element={
              <Layout>
                <GalleryCN />
              </Layout>
            }
          />

          <Route
            path='/blog'
            element={
              <Layout>
                <Blog />
              </Layout>
            }
          />
          <Route
            path='/single-blog'
            element={
              <Layout>
                <BlogSinglePage />
              </Layout>
            }
          />

          <Route
            path='/single-blog2'
            element={
              <Layout>
                <BlogSinglePage2 />
              </Layout>
            }
          />
          <Route
            path='/single-blog3'
            element={
              <Layout>
                <BlogSinglePage3 />
              </Layout>
            }
          />
                  <Route
            path='/bartender'
            element={
              <Layout>
                <BartenderCevatur />
              </Layout>
            }
          />

        <Route
            path='/bartender'
            element={
              <Layout>
                <BartenderCevatur />
              </Layout>
            }
          />

                  <Route
            path='/aviacion'
            element={
              <Layout>
                <AviacionComercialCevatur />
              </Layout>
            }
          />
          
          <Route
            path='/profav'
            element={
              <Layout>
                <TeamSection />
              </Layout>
            }
          />
        <Route
            path='/cheff'
            element={
              <Layout>
                <ChefCevatur />
              </Layout>
            }
            
          />
                  <Route
            path='/loader'
            element={
              <Layout>
                <Trayectoria />
              </Layout>
            }
          />
        <Route
            path='/trayectoria'
            element={
              <Layout>
                <Trayectoria />
              </Layout>
            }
          />

        </Routes>

        
      </BrowserRouter>
    </>
  )
}

export default App